module.exports = __webpack_public_path__ + "static/media/credsystem.b1cacbb7.png";